<template lang='pug'>
#actions
  v-row(no-gutters style='padding: 0 0 16px 0; width: 100%;')
    v-col(xs='12' sm='4' cols='4')
      .titleLabel.colorDark(style='margin-top: 12px;')
        | {{$t('actions.actionType')}}
      md-field(style='margin-top: 0;')
        md-select(
          :disabled='readOnly'
          style='background-color: rgb(244, 244, 244); padding-left: 4px;'
          v-model='action.name')
          md-option(value='ApiRequest') Request Template
  v-row(no-gutters style='padding: 0px; width: 100%;')
    .titleLabel.colorDark
      | {{$t('actions.chooseTheTemplate')}}
  v-row(no-gutters style='width: 100%;')
    v-col(cols='12' style='align-self: flex-end')
      v-row(
        no-gutters
        style='justify-content: space-between; margin-top: 12px;')
        v-col(style='padding: 0 8px 0 0;')
          md-field(style='margin-top: 0;')
            DataProvider(
              style='width: 100%;'
              endpoint='/request-templates'
              @success='newItems',
              :baseUrl='baseUrl',
              :filter='filter')
              div(slot-scope='{ data: response, error, loading }')
                v-combobox(
                  v-if='response',
                  :loading='loading'
                  v-model='originalTemplate'
                  @input='onUpdateOriginalTemplate'
                  @click:clear='removeTemplate',
                  :search-input.sync='search',
                  :disabled='readOnly',
                  :items='response.data || []'
                  item-text='_source.name'
                  return-object
                  hide-details
                  :placeholder="$t('actions.chooseTemplate')"
                  filled
                  dense
                  background-color='rgb(244, 244, 244)'
                  color='#9c27b0'
                  style='border-radius: 0px'
                  clearable
                  ref='templateSelect')
                  template(
                    v-if='response && response.data.length !== response.total'
                    v-slot:append-item)
                    v-list-item(@click='morePerPage')
                      v-icon(style='margin-right: 10px;') mdi-chevron-down
                      v-list-item-title {{ $t("commonPhrases.loadMore") }}...

  template(v-if='requestTemplate')
    slide-y-down-transition
      RequestTemplate(
        v-model='requestTemplate',
        :readOnly='readOnly',
        :config='requestTemplateConfig'
        @changes='applyChanges')
</template>

<script>
import VJsoneditor from 'v-jsoneditor'
import ObjectEditor from '@/components/ObjectEditor'
import URLPreviewer from '@/components/Reuse/URLPreviewer'
import JSONPreviewer from '@/components/Reuse/JSONPreviewer'
import DataProvider from '@/components/DataProvider'
import RequestTemplate from '@/components/RequestTemplate'
import clonedeep from 'lodash.clonedeep'
import RequestTemplatesApi from '@/api/requestTemplates'
import debounce from 'lodash.debounce'
import merge from 'lodash.merge'
// import { axiosTemplatesInstance } from '@/api'

export default {
  name: 'DialogAction',
  components: {
    VJsoneditor,
    ObjectEditor,
    URLPreviewer,
    JSONPreviewer,
    DataProvider,
    RequestTemplate
  },
  model: {
    prop: 'action',
    event: 'update'
  },
  props: {
    action: {
      type: Object,
      default: () => ({})
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  async mounted () {
    if (this.action.parameters?.templateId) {
      this.loading = true
      const templateApi = new RequestTemplatesApi()
      const response = await templateApi.getById(
        this.action.parameters?.templateId,
        this.action.parameters?.isGlobal
      )
      if (!response.error) {
        this.originalTemplate = response.result
        this.setupRequestTemplate()
      }
      this.loading = false
    }
  },
  watch: {
    search: 'applySearch'
  },
  data () {
    return {
      search: '',
      loading: false,
      originalTemplate: null,
      requestTemplate: null,
      baseUrl: process.env.VUE_APP_BACKEND_BASE_URL,
      filter: {
        page: 0,
        perPage: 5
      }
    }
  },
  computed: {
    requestTemplateConfig () {
      return {
        hide: {
          name: true,
          protocol: true,
          requestType: true
        },
        host: { disabled: true },
        path: { disabled: true },
        method: { disabled: true },
        pathParams: {
          initialObject: this.originalTemplate?._source?.pathParameters || {},
          disableRemovingAllProps: true
        },
        hostParams: {
          initialObject: this.originalTemplate?._source?.hostParameters || {},
          disableRemovingAllProps: true
        },
        bodyParams: {
          initialObject: this.originalTemplate?._source?.bodyParameters || {},
          disableRemovingAllProps: true
        },
        queryParams: {
          initialObject: this.originalTemplate?._source?.queryParameters || {},
          readOnlyKeys: true,
          disableRemovingInitialProps: true
        },
        headers: {
          initialObject: this.originalTemplate?._source?.headers || {},
          readOnlyKeys: true,
          disableRemovingInitialProps: true
        },
        bodyJson: {
          readOnly: true,
          previewMode: true,
          bodyParameters: this.requestTemplate?.bodyParameters || {}
        }
      }
    }
  },
  methods: {
    onUpdateOriginalTemplate () {
      this.resetAction()
      this.setupRequestTemplate()
    },
    removeTemplate () {
      this.originalTemplate = null
      this.requestTemplate = null
    },
    resetAction () {
      this.action.parameters = {
        templateId: this.originalTemplate?._id
      }
    },
    setupRequestTemplate () {
      const { templateId, isGlobal, ...otherParameters } =
        this.action?.parameters || {}
      this.requestTemplate = merge(
        clonedeep(this.originalTemplate?._source),
        otherParameters
      )
    },
    newItems (response) {
      if (this.openCombobox === true) {
        this.$nextTick(() => {
          this.$refs.templateSelect.activateMenu()
          this.$refs.templateSelect.isFocused = true
          this.openCombobox = false
        })
      }
    },
    applySearch: debounce(function (val) {
      if (val === this.originalTemplate?._source?.name) {
        return
      }
      if (val) {
        this.filter = {
          q: val,
          page: 0,
          perPage: 5
        }
      } else {
        this.filter = {
          page: 0,
          perPage: 5
        }
      }
    }, 400),
    morePerPage () {
      this.openCombobox = true
      if (!this.filter) {
        this.filter = {
          page: 0,
          perPage: 5
        }
      } else {
        this.filter.perPage += 10
      }
    },
    applyChanges (changes) {
      // eslint-disable-next-line camelcase
      const { result_variable, ...otherChanges } = changes
      const parameters = {
        templateId: this.originalTemplate?._id,
        isGlobal: this.originalTemplate?._source?.isGlobal,
        ...otherChanges
      }
      const updatedAction = {
        ...this.action,
        parameters,
        // eslint-disable-next-line camelcase
        result_variable: result_variable || this.action.result_variable
      }
      this.$emit('update', updatedAction)
    },
    updateObjValues (valuesToUpdt, values) {
      valuesToUpdt = values
    },
    transformTemplateData (templates) {
      return templates?.data || templates
    }
  }
}
</script>

<style scoped>
#actions {
  margin-bottom: 46px;
}
.contextInput {
  background-color: rgb(244, 244, 244) !important;
  padding-left: 4px !important;
}
.disable-click {
  pointer-events: none;
  color: grey !important;
}
.jsoneditor {
  border: thin solid rgba(67, 160, 72, 0);
}
.jsoneditor-menu {
  background-color: rgb(67, 160, 71);
  border-bottom: 1px solid rgb(67, 160, 71);
}
.jsoneditor-menu a.jsoneditor-poweredBy {
  display: none;
}
</style>
